<section>
  <kendo-gridlayout [rows]="['auto', 'auto']" [gap]="{rows: 15, cols: 16}" [cols]="['repeat(6,minmax(0,1fr))']">
    <kendo-gridlayout-item>
      <app-contact-multi-select-kendo placeholder="Select customers" label="Customers" [filters]="sageContactFilters"
        [selectedId]="filterByIdValue(filterTypes.CustomerName)"
        (selectionChanged)="setFilters($event, filterTypes.CustomerName)">
      </app-contact-multi-select-kendo>
    </kendo-gridlayout-item>

    <kendo-gridlayout-item [colSpan]="2">
      <div class="kendo-formfield date-range-wrapper">
        <kendo-daterange style="gap: 0;" #dateRangePicker>
          <kendo-label text="Invoice Date (Start)" class="mr-16 width100">
            <kendo-dateinput #startDateRange #startDateInput="ngModel" name="startDateInput" calendarType="classic"
              class="dateinput width100" placeholder="Start Date" [fillMode]="'outline'" kendoDateRangeStartInput
              [(ngModel)]="invoiceDateRange.startDate" (blur)="updateDateFilters()"
              (ngModelChange)="updateDateFilters()" (click)="focusDateInput(true)"
              (keydown.enter)="appliedFilters()"></kendo-dateinput>
          </kendo-label>
          <kendo-label text="Invoice Date (End)" class="width100">
            <kendo-dateinput #endDateRange #endDateInput="ngModel" name="endDateInput" calendarType="classic"
              class="mr-0 dateinput width100" placeholder="End Date" [fillMode]="'outline'" kendoDateRangeEndInput
              [(ngModel)]="invoiceDateRange.endDate" (blur)="updateDateFilters()" (ngModelChange)="updateDateFilters()"
              (click)="focusDateInput(false)" (keydown.enter)="appliedFilters()"></kendo-dateinput>
          </kendo-label>
          <kendo-daterange-popup #dateRangePickerPopup autoCorrectOn="blur"></kendo-daterange-popup>
        </kendo-daterange>
      </div>
    </kendo-gridlayout-item>

    <kendo-gridlayout-item [colSpan]="2">
      <app-bookkeeping-email-filter [(operator)]="emailFilterOperator" [(text)]="emailFilterText"
        (filterChange)="onEmailFilterChange()" (enterPressed)="appliedFilters()">
      </app-bookkeeping-email-filter>
    </kendo-gridlayout-item>

    <kendo-gridlayout-item class="filter-actions">
      <div class="mr-16 applied-filter">
        <kendo-label text=""></kendo-label>
        <div>
          <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" (click)="appliedFilters()"
            [disabled]="!isFormValid">Apply Filters</kendo-button>
        </div>
      </div>
      <div class="mt-5 clear-filter">
        <kendo-label text=""></kendo-label>
        <div>
          <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" (click)="clearAll()">Clear
            All</kendo-button>
        </div>
      </div>
    </kendo-gridlayout-item>

    <kendo-gridlayout-item>
      <div class="kendo-formfield left-search-icon">
        <kendo-label text="Invoice Number"></kendo-label>
        <div style="position: relative;">
          <i class="fa fa-search" aria-hidden="true"></i>
          <kendo-textbox [value]="filterValue(filterTypes.InvoiceNumber) || ''"
            (valueChange)="setFilters($event, filterTypes.InvoiceNumber)" (keydown.enter)="appliedFilters()"
            placeholder="Enter invoice number" fillMode="outline" [clearButton]="false">
          </kendo-textbox>
        </div>
      </div>
    </kendo-gridlayout-item>

    <kendo-gridlayout-item [colSpan]="2">
      <div class="kendo-formfield date-range-wrapper">
        <kendo-daterange style="gap: 0;" #dueDatePicker>
          <kendo-label text="Due Date (Start)" class="mr-16 width100">
            <kendo-dateinput #dueStartDateRange #dueStartDateInput="ngModel" name="dueStartDateInput"
              calendarType="classic" class="dateinput width100" placeholder="Start Date" [fillMode]="'outline'"
              kendoDateRangeStartInput [(ngModel)]="dueDatePickerRange.startDate" (blur)="updateDueDateFilters()"
              (ngModelChange)="updateDueDateFilters()" (click)="focusDueDateInput(true)"
              (keydown.enter)="appliedFilters()"></kendo-dateinput>
          </kendo-label>
          <kendo-label text="Due Date (End)" class="width100">
            <kendo-dateinput #dueEndDateRange #dueEndDateInput="ngModel" name="dueEndDateInput" calendarType="classic"
              class="mr-0 dateinput width100" placeholder="End Date" [fillMode]="'outline'" kendoDateRangeEndInput
              [(ngModel)]="dueDatePickerRange.endDate" (blur)="updateDueDateFilters()"
              (ngModelChange)="updateDueDateFilters()" (click)="focusDueDateInput(false)"
              (keydown.enter)="appliedFilters()"></kendo-dateinput>
          </kendo-label>
          <kendo-daterange-popup #dueDatePickerPopup autoCorrectOn="blur"></kendo-daterange-popup>
        </kendo-daterange>
      </div>
    </kendo-gridlayout-item>

    <kendo-gridlayout-item>
      <div class="kendo-formfield">
        <kendo-label text="Open Balance"></kendo-label>
        <div class="numeric-text-suffix">
          <kendo-numerictextbox [value]="filterValue(filterTypes.TotalAmountDue) || ''" min="0"
            (valueChange)="setFilters($event, filterTypes.TotalAmountDue)" (keydown.enter)="appliedFilters()"
            placeholder="Enter open balance" fillMode="outline">
          </kendo-numerictextbox>
        </div>
      </div>
    </kendo-gridlayout-item>

    <kendo-gridlayout-item>
      <div class="kendo-formfield">
        <kendo-label text="Aging Start"></kendo-label>
        <div class="numeric-text-suffix">
          <kendo-numerictextbox [(value)]="agingRange.start" (valueChange)="updateAgingFilters()"
            (keydown.enter)="appliedFilters()" [decimals]="0" format="n0" placeholder="Start" fillMode="outline">
          </kendo-numerictextbox>
        </div>
        <kendo-formerror *ngIf="agingRange.end !== null && agingRange.start === null">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>&nbsp; This field is required
        </kendo-formerror>
      </div>
    </kendo-gridlayout-item>

    <kendo-gridlayout-item>
      <div class="kendo-formfield">
        <kendo-label text="Aging End"></kendo-label>
        <div class="numeric-text-suffix">
          <kendo-numerictextbox [(value)]="agingRange.end" [decimals]="0" format="n0"
            (valueChange)="updateAgingFilters()" (keydown.enter)="appliedFilters()" placeholder="End"
            fillMode="outline">
          </kendo-numerictextbox>
        </div>
        <kendo-formerror *ngIf="agingRange.start !== null && agingRange.end === null">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>&nbsp; This field is required
        </kendo-formerror>
      </div>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item>
      <div class="kendo-formfield left-search-icon">
        <kendo-label text="Reference Number"></kendo-label>
        <div style="position: relative;">
          <i class="fa fa-search" aria-hidden="true"></i>
          <kendo-textbox [value]="filterValue(filterTypes.ReferenceNumber) || ''"
            (valueChange)="setFilters($event, filterTypes.ReferenceNumber)" (keydown.enter)="appliedFilters()"
            placeholder="Enter reference number" fillMode="outline" [clearButton]="false">
          </kendo-textbox>
        </div>
      </div>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item [colSpan]="2">
      <app-bookkeeping-company-filter [(operator)]="companyFilterOperator" [(selectedCompanyIds)]="companyFilterIds"
        [companyFilters]="defaultCompanyFilters" (filterChange)="onCompanyFilterChange($event)"
        (enterPressed)="appliedFilters()">
      </app-bookkeeping-company-filter>
    </kendo-gridlayout-item>
  </kendo-gridlayout>
</section>
